module.exports = "/images/lang.svg?849375554d813054b4be16f22135be10";